import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import DataTableMUI from "../../components/common/DataTable";
import { blogsColumns } from "../../services/tableColomn";
import ViewDataPopup from "./viewDataPopup";
import { deleteBlog, getAllBlogs, undoDeleteBlog } from "../../redux/slices/blogsSlice";
import { useNavigate } from "react-router-dom";

const statusOptions = [
  { value: "all", label: "ALL", color: "#2563eb" },
  { value: "active", label: "ACTIVE", color: "#388e3c" },
  { value: "inactive", label: "INACTIVE", color: "#bfa100" },
  { value: "deleted", label: "DELETED", color: "#d32f2f" },
];

const Blogs = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { blogs, loading, statusCounts, pagination } = useAppSelector(
    (state) => state.blogs
  );

  console.log(blogs, "====blogs");

  const [viewPopupOpen, setViewPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      getAllBlogs({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );
  }, [dispatch, statusFilter, page, search, itemsPerPage, sortKey, sortOrder]);

  const refetch = () =>
    dispatch(
      getAllBlogs({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(1);
  };

  const handlePageChange = (newPage) => setPage(newPage);
  const handleView = (row) => {
    setSelectedRow(row);
    setViewPopupOpen(true);
  };

  const handleEdit = (row) => {
    // Navigate to form with the row data as state
    navigate("/blogs-form", { state: { editData: row } });
  };

  const handleDelete = async (row) => {
    if (window.confirm("Are you sure you want to delete this field?")) {
      await dispatch(deleteBlog(row._id));
      refetch();
    }
  };
  const handleUndo = async (row) => {
    await dispatch(undoDeleteBlog(row._id));
    refetch();
  };

  const handleSort = (col) => {
    if (!col.sortable) return;
    setSortKey(col.accessor);
    setSortOrder(
      sortKey === col.accessor && sortOrder === "asc" ? "desc" : "asc"
    );
    setPage(1);
  };

  const handleSearch = () => {
    setSearch(searchInput);
    setPage(1);
  };

  const handleAddClick = () => {
    navigate("/blogs-form"); 
  };

  // Add counts to statusOptions
  const statusOpts = statusOptions.map((opt) => ({
    ...opt,
    count: statusCounts?.[opt.value] || 0,
  }));

  return (
    <div>
      <div className="data-table">
        <DataTableMUI
          title="Blogs"
          columns={blogsColumns}
          data={blogs || []}
          statusOptions={statusOpts}
          statusCounts={statusCounts}
          statusFilter={statusFilter}
          onStatusFilterChange={handleStatusChange}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onUndo={handleUndo}
          pagination
          itemsPerPage={itemsPerPage}
          currentPage={pagination?.page || 1}
          totalItems={pagination?.total || 0}
          setItemsPerPage={setItemsPerPage}
          onPageChange={handlePageChange}
          searchable
          searchTerm={searchInput}
          setSearchTerm={setSearchInput}
          onSearch={handleSearch}
          onAdd
          onAddClick={handleAddClick}
          loading={loading}
          sortKey={sortKey}
          sortOrder={sortOrder}
          onSort={handleSort}
        />
        <ViewDataPopup
          open={viewPopupOpen}
          onClose={() => setViewPopupOpen(false)}
          data={selectedRow}
        />
      </div>
    </div>
  );
};

export default Blogs;
